'use strict';

export const RepublicanDelegateCount = 2472;
export const DemocraticDelegateCount = 4764;

export const RepublicanColor = 'rgba(222, 26, 34, 0.6)';
export const DemocraticColor = 'rgba(3, 110, 171, 0.6)';

export const Candidates = {
  democrats: [
    'Hillary Clinton',
    'Bernie Sanders'
  ],
  republicans: [
    'Donald Trump',
    'Ben Carson',
    'Ted Cruz',
    'Carly Fiorina',
    'Jeb Bush',
    'John Kasich',
    'Rand Paul',
    'Marco Rubio',
    'Mike Huckabee'
  ]
};

export const TEASERS = [
  {
    id: 'kandidaterna.jpg',
    title: 'Presidentkandidaterna',
    url: 'http://pejl.svt.se/usa-val/kandidaterna'
  },
  {
    id: 'quiz.jpg',
    title: 'När valdes presidenten?',
    url: 'http://pejl.svt.se/usa-val/quiz'
  }
];



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/helpers/constants.js
 **/